import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Footer from './Homepages/Footer';
import { Helmet } from 'react-helmet';

const InfoSection = () => {
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    phone: '',
    is_agree: false,
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value, // Handle checkbox separately
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setValidationErrors({}); // Clear previous validation errors

    if (!formData.is_agree) {
      toast.error('You must agree to the privacy statement and understand how your personal data will be processed.');
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await axios.post(
        'https://admin.techno-elevators.com/api/saveTheContactUsDetails',
        formData
      );

      if (response.status === 200) {
        toast.success('Message sent successfully!');
        setFormData({ fullname: '', email: '', phone: '', is_agree: false, message: '' });
      } else {
        toast.error('Failed to send message. Please try again later.');
      }
    } catch (error) {
      // Handle server-side validation errors for all fields
      if (error.response && error.response.data && error.response.data.data) {
        const errors = error.response.data.data;

        // Loop through all the fields (fullname, email, phone, message) to display errors
        Object.keys(errors).forEach((field) => {
          const errorMessages = errors[field];
          if (errorMessages && Array.isArray(errorMessages)) {
            // If there are multiple error messages for a field
            errorMessages.forEach((message) => {
              toast.error(`${field}: ${message}`);
            });
          }
        });
      } else {
        toast.error('An error occurred while sending the message.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
    <Helmet>
      <title>
      Contact Us | Modern Elevators in Muscat | Hurry Up!!
      </title>
      <meta name="description" content="Need to modernize your old elevators or need to install new elevators or escalators for your office building? For any type of query just contact us and get the best." />

    </Helmet>
      <Container fluid style={{ padding: '0px' }}>
        <section className="contact_section long_section">
          <Container>
            <Row>
              <div className="text-center mb-5 mt-5 section-title">
                <p>Contact Us</p>
              </div>

              <Col md={6} style={{ paddingLeft: '7px' }}>
                <div className="form_container">
                  <Form onSubmit={handleSubmit}>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name="fullname"
                        placeholder="Your Name"
                        value={formData.fullname}
                        onChange={handleChange}
                        className='input-field'
                       
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name="phone"
                        placeholder="Mobile Number"
                        value={formData.phone}
                        onChange={handleChange}
                        className='input-field'
                       
                      />
                      {validationErrors.phone && (
                        <div className="text-danger mt-2">{validationErrors.phone}</div>
                      )}
                    </Form.Group>
                    <Form.Group>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        className='input-field'
                       
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name="message"
                        placeholder="Message"
                        className="message-box input-field"
                        value={formData.message}
                        onChange={handleChange}
                       
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Check
                        type="checkbox"
                        className='is_agree'
                        name="is_agree"
                        label="I agree to the privacy statement and understand how my personal data will be processed."
                        checked={formData.is_agree}
                        onChange={handleChange}
                      
                      />
                    </Form.Group>
                    <div className="btn_box text-center">
                      <Button type="submit" disabled={isSubmitting}>
                        {isSubmitting ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{' '}
                            Submitting...
                          </>
                        ) : (
                          'SEND'
                        )}
                      </Button>
                    </div>
                  </Form>
                </div>
              </Col>

              <Col md={6} style={{ paddingRight: '0px' }}>
                <div className="map_container">
                  <div className="map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d15968.111025861048!2d58.39836609506744!3d23.585038294896684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1sen!2sin!4v1732708288873!5m2!1sen!2sin"
                      width="100%"
                      height="500px"
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Google Map"
                    ></iframe>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Container>
      <ToastContainer />
      <Footer />
    </>
  );
};

export default InfoSection;
